import { Component, input } from '@angular/core';

/**
 * FormFieldErrorComponent
 * Reusable component for displaying form field validation errors
 * Used across forms to maintain consistent error display
 */
@Component({
  selector: 'app-form-field-error',
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss'],
  standalone: false
})
export class FormFieldErrorComponent {
  /**
   * Whether to show the error message
   */
  show = input<boolean>(false);

  /**
   * The error message to display
   */
  message = input<string>('');
}
